export default __webpack_public_path__ + "static/media/HeroMobile.504ad15a.jpg";